import { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getSearchState = (state: RootState) => state.search;

export const getSearchItemById = createSelector(
    getSearchState,
    (state, id: string) => id,
    (search, id) => search.list[id]
);

export const getCurrentSearchFolder = createSelector(getSearchState, search => search['/']);

export const getSearchList = createSelector(getCurrentSearchFolder, (state): string[] => state.childs);
